import { atom } from "recoil";
import { Mode } from "../types/index";
export const modeState = atom<Mode>({
  key: "modeState",
  default: "lite",
});
